import {
  IonAlert,
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonLabel,
  IonModal,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonSkeletonText,
  IonSpinner,
  IonTitle,
  IonToolbar,
  useIonViewDidEnter,
} from "@ionic/react";
import { useHistory } from "react-router";

import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import { useEffect, useRef, useState } from "react";

import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import DateUtils from "../../../lib/DateUtils";
import _ from "underscore";
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import onboardLocations from "../../../assets/img/icons/locations.svg";
import { closeCircleOutline } from "ionicons/icons";
import LocationSearchInputV2 from "../../../components/Map/LocationSearchInputV2";
import MapUtils from "../../../lib/MapUtils";

const AppUserLocationPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const pageRef = useRef();

  const [user, setUser] = useState<any>(null);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [locationServicesAlert, setLocationServicesAlert] =
    useState<boolean>(false);

  const [filterOption, setFilterOption] = useState<string>("all");

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    StorageUtils.get("user_customer").then((user) => {
      setUser(user);
    });

    loadStores();
  }, []);

  const [loadingStores, setLoadingStores] = useState<boolean>(false);
  const [allStores, setAllStores] = useState<any[]>([]);
  const [filteredStores, setFilteredStores] = useState<any[]>([]);
  const [location, setLocation] = useState<any>(null);

  const getStoreDistance = (coordinates: any, store: any) => {
    let distance: any = MapUtils.calculateDistanceInMiles(
      coordinates?.lat,
      coordinates?.lng,
      store?.location?.geographic?.lat,
      store?.location?.geographic?.lng,
    );

    distance = Math.round(distance * 100) / 100;

    return distance;
  };

  useEffect(() => {
    if (location?.geographic && allStores?.length) {
      loadStoreResults(allStores, location?.geographic);
    }
  }, [location, allStores]);

  const reverseGeocodeLocation = async (lat: any, lng: any) => {
    let res: any = await API.reverseGeocodeLatLng(lat, lng);

    let result = res?.data?.data?.geocode?.results?.length
      ? res?.data?.data?.geocode?.results[0]
      : null;
    let geographic = {
      lat: lat,
      lng: lng,
    };

    setLocation({ result, geographic });
    setFilterOption("nearby");
  };

  const loadStoreResults = async (stores: any, coordinates: any) => {
    let filteredStores = _.filter(stores, (store: any) => {
      let distance = getStoreDistance(coordinates, store);

      return distance <= 25;
    });

    filteredStores = _.sortBy(filteredStores, (store: any) => {
      return getStoreDistance(coordinates, store);
    });

    setFilteredStores(filteredStores);
  };

  let loadStores = async () => {
    setLoadingStores(true);

    return new Promise((resolve, reject) => {
      API.getStores()
        .then(
          (data: any) => {
            let stores = data?.data?.data?.stores?.length
              ? data?.data?.data?.stores
              : [];

            stores = _.filter(stores, (store: any) => {
              return (
                store &&
                (DateUtils.storeIsPrelaunch(store) ||
                  DateUtils.storeIsLive(store))
              );
            });

            stores = _.filter(stores, (store: any) => {
              return store?.type === "retail";
            });

            stores = stores.map((st: any) => {
              st.name = st.name?.replace("Project LeanNation", "PLN").trim();

              if (st?.location?.address?.city) {
                st.location.address.city = st.location.address.city?.trim();
              }

              return st;
            });

            stores = _.sortBy(stores, "name");

            setAllStores(stores);

            if (location?.geographic) {
              loadStoreResults(stores, location?.geographic);
            } else {
              setFilteredStores(stores);
            }

            resolve(stores);
          },
          (e) => {
            console.error(e);

            reject(e);
          },
        )
        .finally(() => {
          setLoadingStores(false);
        });
    });
  };

  const selectLocation = (store: any) => {
    setSubmitting(store?._id);

    API.setAppUserParameter("storeID", store?._id)
      .then(async (data: any) => {
        setUser(data?.data?.data?.user);

        await StorageUtils.set("user_customer", data?.data?.data?.user);

        API.getAccount()
          .then(
            async (data: any) => {
              setUser(data?.data?.data?.user);

              await StorageUtils.set("user_customer", data?.data?.data?.user);
              await StorageUtils.set("user_store", data?.data?.data?.store);
            },
            (e) => {
              console.error(e);
            },
          )
          .finally(() => {
            next();
            setUser(user);
            setModalOpen(false);
            setSubmitting(false);
          });
      })
      .catch((e) => {
        console.error(e);

        setSubmitting(false);
      })
      .finally(() => {});
  };

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>Find My Store</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"Find My Store"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding">
          <div
            className="text-center flex h-full items-center"
            style={{
              height: "calc(100vh - 350px)",
            }}
          >
            <div className="mx-auto">
              <div className="rounded w-full min-h-[300px] max-h-[300px] sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
                <img
                  src={onboardLocations}
                  alt="PLN+"
                  className="w-auto h-full mx-auto max-h-[300px] sm:max-h-[350px] object-contain"
                />
              </div>

              <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.5rem]">
                Find Your PLN Location
              </h2>

              <p className="" style={{ fontSize: 18 }}>
                Find your closest PLN community and tap into the guidance,
                meals, and accountability that fuel success.
              </p>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() ? "web" : ""
          }`}
        >
          <IonButton
            onClick={() => {
              if (Capacitor.isNativePlatform()) {
                Geolocation.requestPermissions()
                  .then((permissions) => {
                    if (
                      permissions.location === "granted" ||
                      permissions.coarseLocation === "granted"
                    ) {
                      Geolocation.getCurrentPosition()
                        .then(async (position) => {
                          if (position.coords) {
                            reverseGeocodeLocation(
                              position.coords.latitude,
                              position.coords.longitude,
                            );
                          }

                          setModalOpen(true);
                        })
                        .catch((err) => {
                          setLocationServicesAlert(true);
                        });
                    } else {
                      setLocationServicesAlert(true);
                    }
                  })
                  .catch((err) => {
                    setLocationServicesAlert(true);
                  });
              } else if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  async (position) => {
                    if (position.coords) {
                      reverseGeocodeLocation(
                        position.coords.latitude,
                        position.coords.longitude,
                      );
                    }

                    setModalOpen(true);
                  },
                  (err) => {
                    console.log(err);
                    setModalOpen(true);
                  },
                  {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0,
                  },
                );
              }
            }}
            expand="block"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() === "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Find My Location
          </IonButton>
          <IonButton
            onClick={async () => {
              next();
            }}
            expand="block"
            color="dark"
            fill="clear"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() === "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Maybe Later
          </IonButton>
        </IonToolbar>
      </IonFooter>
      <IonAlert
        isOpen={locationServicesAlert}
        onDidDismiss={() => setLocationServicesAlert(false)}
        header="Location Access Unavailable"
        message={
          Capacitor.getPlatform() === "android"
            ? "Location is disabled or not allowed for this app. Go to Settings → Location to enable it, then try again."
            : "Location is disabled or not allowed for this app. Go to Settings → Privacy & Security → Location Services to enable it, then try again."
        }
        buttons={["OK"]}
      />
      <IonModal
        className="modal-mealdetail"
        mode={Capacitor.getPlatform() === "android" ? "md" : "ios"}
        isOpen={modalOpen}
        onDidDismiss={() => setModalOpen(false)}
      >
        <IonHeader>
          <IonToolbar
            mode={Capacitor.getPlatform() === "android" ? "md" : "ios"}
            className={
              Capacitor.isNativePlatform()
                ? "box-modal-toolbar-native"
                : "box-modal-toolbar-web"
            }
            style={{ borderBottom: "none" }}
          >
            <IonTitle>Choose Your Location</IonTitle>
            <IonButtons slot="start">
              <IonButton onClick={() => setModalOpen(false)}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div className="px-4 pt-3">
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="">
                {location ? (
                  <>
                    <div className="rounded relative">
                      <div className="absolute left-2 top-3 sm:top-3.5 sm:left-2.5 text-lg h-[2rem] w-[2rem]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="h-[1.3rem] w-[1.3rem]"
                        >
                          <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                          <circle cx="12" cy="10" r="3" />
                        </svg>
                      </div>
                      <p className="block whitespace-nowrap overflow-hidden text-ellipsis w-full text-base sm:text-md pr-[2.25rem] pl-[2.25rem] rounded-tr rounded-tl border-0 py-2.5 sm:py-3 text-gray-900 shadow-sm outline-0 border-[1px] border-gray-100 placeholder:text-gray-400 transition-all focus:border-orange-500 sm:leading-6 rounded-br rounded-bl">
                        {location?.result?.formatted_address}
                      </p>
                      <div
                        onClick={() => {
                          setLocation(null);
                          setFilterOption("all");
                        }}
                        className="cursor-pointer absolute right-2.5 top-3 sm:top-3.5 sm:right-3 text-2xl h-[2rem] w-[1.5rem]"
                      >
                        <IonIcon
                          icon={closeCircleOutline}
                          className="text-gray-900"
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <LocationSearchInputV2
                      onChange={() => {}}
                      onSelect={(data: any) => {
                        setFilterOption("nearby");

                        setLocation(data);
                      }}
                    ></LocationSearchInputV2>
                  </>
                )}
              </div>
            </form>
            <div className="my-3 h-[1px] bg-gray-100"></div>
            <IonSegment
              disabled={loadingStores}
              value={filterOption}
              onIonChange={(e: any) => {
                setFilterOption(e.detail.value);
              }}
              mode={Capacitor.getPlatform() === "android" ? "md" : "ios"}
            >
              <IonSegmentButton disabled={!location} value="nearby">
                <IonLabel>Nearby</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="all">
                <IonLabel>All Locations</IonLabel>
              </IonSegmentButton>
            </IonSegment>
            <div className="mt-3">
              {loadingStores ? (
                <>
                  <IonSkeletonText
                    animated
                    className="w-full rounded-lg h-[98px] mb-3"
                  />
                  <IonSkeletonText
                    animated
                    className="w-full rounded-lg h-[98px] mb-3"
                  />
                  <IonSkeletonText
                    animated
                    className="w-full rounded-lg h-[98px] mb-3"
                  />
                  <IonSkeletonText
                    animated
                    className="w-full rounded-lg h-[98px] mb-3"
                  />
                  <IonSkeletonText
                    animated
                    className="w-full rounded-lg h-[98px] mb-3"
                  />
                  <IonSkeletonText
                    animated
                    className="w-full rounded-lg h-[98px] mb-3"
                  />
                </>
              ) : (
                <div>
                  {filterOption === "nearby" ? (
                    <>
                      {filteredStores?.length ? (
                        <>
                          {filteredStores?.map((store: any) => {
                            return (
                              <div
                                onClick={() => {
                                  selectLocation(store);
                                }}
                                className={`p-3 cursor-pointer items-center flex gap-x-3 rounded-lg border border-gray-100 mb-3 ${
                                  submitting
                                    ? "bg-gray-50 text-gray-300"
                                    : "text-gray-900"
                                }`}
                                key={store?._id}
                              >
                                <div className="grow">
                                  <p className="text-base font-[SourceSerif]">
                                    {store?.name}
                                    {location?.geographic ? (
                                      <span className="pl-1.5 text-sm relative -top-[1px]">
                                        (
                                        {getStoreDistance(
                                          location?.geographic,
                                          store,
                                        )?.toFixed(1)}{" "}
                                        mi)
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </p>
                                  <p className="text-sm">
                                    {store?.location?.address?.formattedAddress}
                                  </p>
                                </div>
                                <div>
                                  {submitting === store?._id ? (
                                    <IonSpinner name="dots"></IonSpinner>
                                  ) : null}
                                  {!submitting ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      className="h-8 w-8"
                                    >
                                      <path d="m9 18 6-6-6-6" />
                                    </svg>
                                  ) : null}
                                </div>
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <div className="rounded-lg border border-gray-100 p-3">
                            <p className="text-base text-lg text-center mb-2 font-[SourceSerif]">
                              No Locations Nearby (Yet!)
                            </p>
                            <p className="text-base text-center">
                              We're growing fast so stay tuned, a PLN community
                              could be coming your way soon!
                            </p>
                            <div className="mt-3">
                              <button
                                onClick={() => {
                                  next();
                                  setModalOpen(false);
                                }}
                                className="w-full rounded-xl bg-orange-500 text-white px-4 py-2.5"
                              >
                                Continue Without A Location
                              </button>
                              <button
                                onClick={() => {
                                  setFilterOption("all");
                                }}
                                className="w-full text-orange-500 px-4 mt-2 py-2"
                              >
                                View All Locations
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {allStores?.map((store: any) => {
                        return (
                          <div
                            onClick={() => {
                              selectLocation(store);
                            }}
                            className={`p-3 cursor-pointer items-center flex gap-x-3 rounded-lg border border-gray-100 mb-3 ${
                              submitting
                                ? "bg-gray-50 text-gray-300"
                                : "text-gray-900"
                            }`}
                            key={store?._id}
                          >
                            <div className="grow">
                              <p className="text-base font-[SourceSerif]">
                                {store?.name}
                                {location?.geographic ? (
                                  <span className="pl-1.5 text-sm relative -top-[1px]">
                                    (
                                    {getStoreDistance(
                                      location?.geographic,
                                      store,
                                    )?.toFixed(1)}{" "}
                                    mi)
                                  </span>
                                ) : (
                                  ""
                                )}
                              </p>
                              <p className="text-sm">
                                {store?.location?.address?.formattedAddress}
                              </p>
                            </div>
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                className="h-8 w-8"
                              >
                                <path d="m9 18 6-6-6-6" />
                              </svg>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </IonContent>
      </IonModal>
    </IonPage>
  );
};

export default AppUserLocationPage;
